import { useState } from 'react';

interface NavbarProps {
  isFixed: boolean;
}

export default function Navbar({ isFixed }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Awards', href: '#awards' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Videos', href: '#videos' },
    { name: 'Personal', href: '#personal' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isFixed ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            className={`text-xl font-bold tracking-tight transition-colors duration-300 cursor-pointer ${
              isFixed ? 'text-black' : 'text-white'
            }`}
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Brayan Fernandez
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className={`px-5 py-2 text-sm font-semibold uppercase tracking-wider transition-all duration-300 cursor-pointer ${
                  isFixed
                    ? 'text-gray-700 hover:text-[#800000] hover:bg-gray-50'
                    : 'text-white hover:text-white hover:bg-white/10'
                }`}
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href="#contact"
              className={`px-6 py-3 text-sm font-semibold uppercase tracking-wider transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isFixed
                  ? 'bg-[#800000] text-white hover:bg-black'
                  : 'bg-white text-black hover:bg-gray-100'
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Get In Touch
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors duration-300 cursor-pointer ${
              isFixed ? 'text-black' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-200 transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 space-y-1">
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-sm font-semibold uppercase tracking-wider text-gray-700 hover:text-[#800000] hover:bg-gray-50 transition-all duration-300 cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.name}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setIsMobileMenuOpen(false)}
            className="block px-4 py-3 text-sm font-semibold uppercase tracking-wider text-center bg-[#800000] text-white hover:bg-black transition-all duration-300 cursor-pointer mt-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Get In Touch
          </a>
        </div>
      </div>
    </nav>
  );
}
